module.exports = __webpack_public_path__ + "img/hk_lv1_active@3x.a360e54f.png";